export var StepConnectorTheme = function (theme) { return ({
    defaultProps: {},
    styleOverrides: {
        line: {
            borderColor: theme.palette.greySecondary[300],
            borderTopStyle: "dotted",
            borderTopWidth: 3,
        },
    },
}); };
export default StepConnectorTheme;
//# sourceMappingURL=theme.js.map